import React from 'react';

class Select extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {data, value, onChange} = this.props;

        return (
            <div className='input-style input-style-1 mb-0 d-flex'>
                <em><i className="fa fa-angle-down"></i></em>
                <select onChange={onChange} value={value}>
                    {data && data.map(({id, name}, index) => {
                        return (
                            <option value={id}>{name}</option>
                        );
                    })}
                </select>
            </div>
        );
    }
}

export default Select;
